export default __webpack_public_path__ + "static/media/africa_exam.541b6407.png";